import { Navigate, useOutletContext, useParams } from 'react-router-dom';

function CaseStudySection() {
  const { caseStudyId, sectionId } = useParams();
  const { sections = [] } = useOutletContext();
  const activeSection = sections.find(section => section.id === sectionId);

  if (!sectionId || !activeSection) {
    return <Navigate to={`/${caseStudyId}/context`} replace />;
  }

  const SectionComponent = activeSection.Component;

  return <SectionComponent />;
}

export default CaseStudySection;
